import React from 'react'
import styles from './style.module.css'
import { Route, Switch, withRouter } from 'react-router-dom'
import RegistrationCertificatesList from './components/registrationCertificatesList'
import {
	NoRegistrationCertificateSelected,
	RegistrationCertificateDetails,
} from './components/RegistrationCertificateDetails'

const RegistrationCertificatesPage = ({ match }) => {
	return (
		<div className='container' style={{ marginTop: 20, display: 'flex' }}>
			<Route path={match.path} component={RegistrationCertificatesList} />
			<div className={styles.divider} />
			<Switch>
				<Route
					exact
					path={match.path}
					component={NoRegistrationCertificateSelected}
				></Route>
				<Route
					path={`${match.path}/:registrationCertificateId`}
					component={RegistrationCertificateDetails}
				/>
			</Switch>
		</div>
	)
}

export default withRouter(RegistrationCertificatesPage)
